import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MqttService, IMqttMessage } from 'ngx-mqtt';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/user/services/login.service';
import { TranslateService } from '@ngx-translate/core';
import { LiftDetail } from '../../models/lift-detail.model';
declare var Shaft: any;

@Component({
  selector: 'app-lift-state',
  templateUrl: './lift-state.component.html',
  styleUrls: ['./lift-state.component.css']
})
export class LiftStateComponent implements OnInit {
  liftId: number;
  lift: LiftDetail;
  shaft: any;
  private subscription: Subscription;
  menu = 'state';

  temperature = 0;
  weight = 0;
  speed = 0;
  mode = 0;
  actualPower = 0;
  allPower = 0;

  //Permissions
  canViewErrors: boolean = false;
  canView: boolean = false;
  canControl: boolean = false;
  canViewParameter: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private mqttService: MqttService,
    private loginService: LoginService,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.liftId = +this.route.snapshot.paramMap.get('id');
    const response = this.route.snapshot.data.state;
    this.lift = this.route.snapshot.data.lift;
    let liftPermission = this.route.snapshot.data.liftPermission;
    if (!liftPermission) {
      liftPermission = [];
    }

    this.canViewErrors = liftPermission.indexOf('2') > -1 || this.loginService.isSuperadmin();
    this.canView = liftPermission.indexOf('0') > -1 || this.loginService.isSuperadmin();
    this.canControl = liftPermission.indexOf('3') > -1 || this.loginService.isSuperadmin();
    this.canViewParameter = liftPermission.indexOf('4') > -1 || this.loginService.isSuperadmin();

    const stateData = response.filter(item => item.type == 0)[0];
    const temperatureData = response.filter(item => item.type == 1)[0];

    this.shaft = new Shaft('svg', this.lift.floorCount);

    if (response.length > 0) {
      this.setLiftState(stateData.data.data);
      if (temperatureData) {
        this.temperature = temperatureData.data.temperature; 
      }    
      this.speed = stateData.data.data.speed;
      this.weight = stateData.data.data.weight;
      this.mode = stateData.data.data.mode;
    }

    this.subscription = this.mqttService.observe('/module/' + String(this.lift.liftModule.code) + '/#').subscribe((message: IMqttMessage) => {
      if (message.topic == '/module/' + String(this.lift.liftModule.code) + '/temperature') {
        const obj = JSON.parse(message.payload.toString());
        this.temperature = obj.temperature;
      }

      if (message.topic == '/module/' + String(this.lift.liftModule.code) + '/lift') {
        let liftData:any = message.payload.toString();
        liftData = JSON.parse(liftData);
        const obj = JSON.parse(liftData);

        this.setLiftState(obj.data);
        this.speed = obj.data.speed;
        this.weight = obj.data.weight;
        this.mode = obj.data.mode;
      }

      if (message.topic == '/module/' + String(this.lift.liftModule.code) + '/power') {
        const objPower = JSON.parse(message.payload.toString());
        this.actualPower = objPower['W'];
        this.allPower = objPower['kWh'];
        console.log(objPower['W']);
      }
    });

    /*this.mqttService.observe('$SYS/brokers').subscribe((message: IMqttMessage) => {
      console.log(message);
    });*/
  }

  setLiftState(data) {
    if (data.direction == 1 && data.floor_level == 0) {
      data.floor = data.floor + 1;
    }

    this.shaft.setDestination(data.destination);
    this.shaft.setPosition(data.floor, data.floor_level);
    this.shaft.setDoor(data.door);
    this.shaft.setCalls({ Car: data.calls.car, FloorUp: data.calls.floor_up, FloorDown: data.calls.floor_dn });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  goToError() {
    this.router.navigate([{ outlets: { modal: ['lift-error', this.liftId] } }]);
  }
}
